
import React from 'react';
import { Utensils, HelpCircle, HeartPulse, Pill } from 'lucide-react';

interface HeaderProps {
  onOpenKitchen: () => void;
  onOpenHealth: () => void;
  onOpenPharmacy: () => void;
  onOpenSettings: () => void;
  onOpenWizard: () => void;
  isRecording: boolean;
}

export const Header: React.FC<HeaderProps> = ({ 
    onOpenKitchen, 
    onOpenHealth,
    onOpenPharmacy,
    onOpenSettings, 
    onOpenWizard, 
    isRecording,
}) => {
  return (
    <header className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-gray-200 dark:border-gray-800 flex-none z-20 pt-safe transition-colors">
        <div className="max-w-md mx-auto px-4 py-3 flex items-center justify-between">
            
            {/* Left: Logo + Name + Wizard Icon */}
            <div className="flex items-center gap-2">
                <div className="w-9 h-9 bg-emerald-500 rounded-xl flex items-center justify-center text-white font-bold shadow-sm shrink-0 text-xl">V</div>
                
                <h1 className="text-base sm:text-lg font-bold text-gray-900 dark:text-white tracking-tight hidden xs:block">VitalEat</h1>

                <button 
                  onClick={onOpenWizard}
                  className="w-10 h-10 rounded-full bg-gray-50 dark:bg-gray-800 flex items-center justify-center text-[#1D4E89] hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors active:scale-95"
                  title="Help Tour"
                >
                   <HelpCircle size={20} strokeWidth={2} />
                </button>
            </div>

            {/* Right: Actions */}
            <div className="flex items-center gap-2">
                {isRecording && (
                    <div className="px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1.5 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border border-red-100 dark:border-red-900/30">
                        <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></div>
                        <span className="hidden sm:inline">REC</span>
                    </div>
                )}

                <button
                  id="header-pharmacy-btn"
                  onClick={onOpenPharmacy}
                  className="w-10 h-10 rounded-full bg-violet-50 dark:bg-violet-900/20 flex items-center justify-center text-violet-500 hover:bg-violet-100 dark:hover:bg-violet-900/40 transition-colors active:scale-95 border border-violet-100 dark:border-violet-800"
                  title="Pharmacy & Medications"
                >
                   <Pill size={20} strokeWidth={2} />
                </button>

                <button
                  id="header-health-btn"
                  onClick={onOpenHealth}
                  className="w-10 h-10 rounded-full bg-rose-50 dark:bg-rose-900/20 flex items-center justify-center text-rose-500 hover:bg-rose-100 dark:hover:bg-rose-900/40 transition-colors active:scale-95 border border-rose-100 dark:border-rose-800"
                  title="Health Records & Devices"
                >
                   <HeartPulse size={20} strokeWidth={2} />
                </button>

                <button
                  id="header-kitchen-btn"
                  onClick={onOpenKitchen}
                  className="w-10 h-10 rounded-full bg-orange-50 dark:bg-orange-900/20 flex items-center justify-center text-orange-600 dark:text-orange-400 hover:bg-orange-100 dark:hover:bg-orange-900/40 transition-colors active:scale-95 border border-orange-100 dark:border-orange-800"
                  title="My Kitchen & Pantry"
                >
                   <Utensils size={20} strokeWidth={2} />
                </button>
                
                <button 
                  id="header-settings-btn"
                  onClick={onOpenSettings} 
                  className="w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors active:scale-95 border border-gray-200 dark:border-gray-700"
                >
                   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" /></svg>
                </button>
            </div>
        </div>
    </header>
  );
};
